'use client';

import { useEffect } from 'react';
import { getConfigValue } from '../lib/public-env/get-config-value';
import {
  initTelemetry,
  setTelemetryUser,
  teardownTelemetry,
} from './telemetry-client';
import type { TelemetryConfig } from '@terra/ui-telemetry';

export function TelemetryProvider() {
  const commitSha = getConfigValue('NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA')?.trim();
  const coralogixDomain = getConfigValue(
    'NEXT_PUBLIC_CORALOGIX_DOMAIN',
  )?.trim();

  useEffect(() => {
    const cleanup = window.electronAPI?.onElectronReady?.(async () => {
      const appInfo: TelemetryConfig = {
        environment: process.env.NODE_ENV,
        appVersion: window.electronAPI.app.getVersion(),
        commitSha,
        platform: window.electronAPI.app.getPlatform(),
        arch: window.electronAPI.app.getArch(),
        desktopVersion: window.electronAPI.app?.getBuildVersion?.() || '',
        coralogixPublicKey: getConfigValue(
          'NEXT_PUBLIC_CORALOGIX_RUM_PUBLIC_KEY',
        )?.trim(),
        coralogixDomain,
      };
      const user = await window.electronAPI?.auth?.getProfile();
      if (user?.success && user?.profile?.sub) {
        initTelemetry(appInfo);

        setTelemetryUser({
          userId: user.profile.sub,
          userName: user.profile.name,
          userEmail: user.profile.email,
        });
      }
    });

    return () => {
      cleanup?.();
      teardownTelemetry();
    };
  }, [commitSha, coralogixDomain]);

  return null;
}
